import { createStyles, makeStyles } from '@material-ui/core';

const styles = () => createStyles({
  statusList: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    flexWrap: 'wrap',
  },
});

export default makeStyles(styles);
